/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Summary_Billing_OffInputs */



/**
* | output |
* | --- |
* | "Billing is switched off for this partner, so nothing is invoiced." |
*
* @param {Partner_Summary_Billing_OffInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_summary_billing_off = /** @type {((inputs?: Partner_Summary_Billing_OffInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Summary_Billing_OffInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Abrechnung ist für diesen Partner ausgeschaltet, es wird nichts in Rechnung gestellt.")
	return /** @type {LocalizedString} */ ("Billing is switched off for this partner, so nothing is invoiced.")
});